import { type ILocationReducer } from '../../interface/IReducer';
import { locationType } from '../types';

const initialState = {} as ILocationReducer;

// const returnObject = <
//   T extends { [key: string]: any },
//   L extends string,
//   R extends { [key: string]: any },
//   K extends string
// >(
//   state: T,
//   stateProp: L,
//   action: R,
//   key: K
// ) => {
//   if (state && stateProp in state) {
//     return {
//       ...state,
//       locationLGAInConsistuency: {
//         ...state[stateProp],
//         [key]: action.payload
//       }
//     }
//   } else {
//     return state
//   }
// }

export default function locationReducer(state: ILocationReducer = initialState, action: any) {
	switch (action.type) {
		case locationType.state.dataAction:
			return {
				...state,
				getAllLocationStates: action.payload,
			};
		case locationType.state.dataLoading:
			return {
				...state,
				getAllLocationStates_Loading: action.payload,
			};
		case locationType.state.dataError:
			return {
				...state,
				getAllLocationStates_Error: action.payload,
			};
		case locationType.zone.dataAction:
			return {
				...state,
				getAllLocationZones: action.payload,
			};
		case locationType.zone.dataLoading:
			return {
				...state,
				getAllLocationZones_Loading: action.payload,
			};
		case locationType.zone.dataError:
			return {
				...state,
				getAllLocationZones_Error: action.payload,
			};
		case locationType.geozone.dataAction:
			return {
				...state,
				getAllLocationGEOZones: action.payload,
			};
		case locationType.geozone.dataLoading:
			return {
				...state,
				getAllLocationGEOZones_Loading: action.payload,
			};
		case locationType.geozone.dataError:
			return {
				...state,
				getAllLocationGEOZones_Error: action.payload,
			};
		case locationType.pollingUnit.dataAction:
			return {
				...state,
				getAllLocationPollingUnits: action.payload,
			};
		case locationType.pollingUnit.dataLoading:
			return {
				...state,
				getAllLocationPollingUnits_Loading: action.payload,
			};
		case locationType.pollingUnit.dataError:
			return {
				...state,
				getAllLocationPollingUnits_Error: action.payload,
			};
		case locationType.pollingUnitsInWard.dataAction:
			return {
				...state,
				getAllLocationPollingUnitsInWard: action.payload,
			};
		case locationType.pollingUnitsInWard.dataLoading:
			return {
				...state,
				getAllLocationPollingUnitsInWard_Loading: action.payload,
			};
		case locationType.pollingUnitsInWard.dataError:
			return {
				...state,
				getAllLocationPollingUnitsInWard_Error: action.payload,
			};
		case locationType.ward.dataAction:
			return {
				...state,
				getAllLocationWards: action.payload,
			};
		case locationType.ward.dataLoading:
			return {
				...state,
				getAllLocationWards_Loading: action.payload,
			};
		case locationType.ward.dataError:
			return {
				...state,
				getAllLocationWards_Error: action.payload,
			};
		case locationType.wardsInLGA.dataAction:
			return {
				...state,
				getAllLocationWardsInLGA: action.payload,
			};
		case locationType.wardsInLGA.dataLoading:
			return {
				...state,
				getAllLocationWardsInLGA_Loading: action.payload,
			};
		case locationType.wardsInLGA.dataError:
			return {
				...state,
				getAllLocationWardsInLGA_Error: action.payload,
			};
		case locationType.wardsInConsistuency.dataAction:
			return {
				...state,
				locationWardsInConsistuency: action.payload,
			};
		case locationType.wardsInConsistuency.dataLoading:
			return {
				...state,
				locationWardsInConsistuency_Loading: action.payload,
			};
		case locationType.wardsInConsistuency.dataError:
			return {
				...state,
				locationWardsInConsistuency_Error: action.payload,
			};
		case locationType.lga.dataAction:
			return {
				...state,
				getAllLocationLGAs: action.payload,
			};
		case locationType.lga.dataLoading:
			return {
				...state,
				getAllLocationLGAs_Loading: action.payload,
			};
		case locationType.lga.dataError:
			return {
				...state,
				getAllLocationLGAs_Error: action.payload,
			};
		case locationType.lgasInState.dataAction:
			return {
				...state,
				getAllLocationLGAsInState: action.payload,
			};
		case locationType.lgasInState.dataLoading:
			return {
				...state,
				getAllLocationLGAsInState_Loading: action.payload,
			};
		case locationType.lgasInState.dataError:
			return {
				...state,
				getAllLocationLGAsInState_Error: action.payload,
			};
		case locationType.party.dataAction:
			return {
				...state,
				getAllParties: action.payload,
			};
		case locationType.party.dataLoading:
			return {
				...state,
				getAllParties_Loading: action.payload,
			};
		case locationType.party.dataError:
			return {
				...state,
				getAllParties_Error: action.payload,
			};
		case locationType.lgasInConsistuency.dataAction:
			return {
				...state,
				locationLGAInConsistuency: action.payload,
			};
		case locationType.lgasInConsistuency.dataLoading:
			return {
				...state,
				locationLGAInConsistuency_Loading: action.payload,
			};
		case locationType.lgasInConsistuency.dataError:
			return {
				...state,
				locationLGAInConsistuency_Error: action.payload,
			};
		case locationType.pollingUnitById.dataAction:
			return {
				...state,
				locationPollingUnitById: action.payload,
			};
		case locationType.pollingUnitById.dataLoading:
			return {
				...state,
				locationPollingUnitById_Loading: action.payload,
			};
		case locationType.pollingUnitById.dataError:
			return {
				...state,
				locationPollingUnitById_Error: action.payload,
			};
		case locationType.constituencyById.dataAction:
			return {
				...state,
				getConstituencyById: action.payload,
			};
		case locationType.constituencyById.dataLoading:
			return {
				...state,
				getConstituencyByIdLoading: action.payload,
			};
		case locationType.constituencyById.dataError:
			return {
				...state,
				getConstituencyByIdError: action.payload,
			};
		default:
			return state;
	}
}
